/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserCurrentResponse } from '../../models/user-current-response';

export interface UsersCurrentGet$Params {
  'Active-Tenant-Identifier': string;
}

export function usersCurrentGet(http: HttpClient, rootUrl: string, params: UsersCurrentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserCurrentResponse>> {
  const rb = new RequestBuilder(rootUrl, usersCurrentGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserCurrentResponse>;
    })
  );
}

usersCurrentGet.PATH = '/users/current';
